import { Typography } from "@maxhub/max-ui"

export const TypographyBodyExample = {
    title: 'Typography.Body',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Hello world',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'variant',
            label: 'variant',
            type: 'enum',
            tsType: ['"small"', '"medium"', '"large"', '"custom"', '"large-strong"', '"medium-strong"', '"small-strong"'],
            default: 'custom',
            options: ['small', 'medium', 'large', 'custom', 'large-strong', 'medium-strong', 'small-strong'],
        },
    ],

    Preview({ props }){
        const bodyProps = {
            ...(props.variant ? { variant: props.variant } : {}),
        }

        return (
            <Typography.Body {...bodyProps}>
                {props.children}
            </Typography.Body>
        )
    },

    getCode(props){
        return `<Typography.Body${props.variant !== 'custom' ? `\n  variant="${props.variant}"` : ''}>
  ${props.children}
</Typography.Body>`
    }

}